import React, { useContext, useEffect, useState } from "react";
import { PileData } from "../components/Pile";
import { GameModel, PileModel, BoardModel } from "../interface/game";
import { GameModelImpl } from "../model/game-model";
import { pileCardModelToCardDisplayProperties, pileIdToPileDisplayProperty } from "./mappers";
import { BoardProperties } from "../components/Board";
import { GamePlayState, GameState } from "../components/Game";

export const gameModel = new GameModelImpl();
export const GameContext = React.createContext<GameModel>(gameModel);

export function useGameState(): [GameState, React.Dispatch<React.SetStateAction<GameState>>] {
    const [gameState, setGameState] = useState<GameState>({ playState: GamePlayState.START, ruleset: 'Klondike' });

    const context = useContext(GameContext);
    useEffect(() => {
        context.subscribeGameState((win: boolean) => setGameState((oldState) => ({
            ...oldState,
            playState: GamePlayState.WIN
        })));
    }, [context]);

    return [gameState, setGameState];
}

export function useGame(): BoardProperties {
    const [board, setBoard] = useState<BoardProperties>({rows:1, cols: 1, piles: []});

    const context = useContext(GameContext);
    useEffect(() => {
        context.subscribeBoardModel((board: BoardModel) => setBoard(() => {
            return {
                rows: board.rows,
                cols: board.cols,
                piles: board.pileIds.map(pileIdToPileDisplayProperty(context))
            }
        }));
    }, [context]);
    return board;
}

export function usePile(pileId: string): PileData {
    const [pile, setPile] = useState<PileData>([]);

    const context = useContext(GameContext);
    useEffect(() => {
        context.subscribePileModel(pileId, (pile: PileModel) => setPile(() => {
            return pile.cards.map(pileCardModelToCardDisplayProperties(context))
        }));
    }, [context, pileId]);
    return pile;
}

export function useGameContext() {
    return useContext(GameContext);
}